// Before/after comparison slider (range input driven, CSS custom-property based).
// Ported from the EverAuburn.com "comp-slider" pattern; supports multiple independent
// sliders per page (the original Auburn version queried the first ".comp-slider" globally).
export default function comparisonSliderInit() {
    const containers = document.querySelectorAll(".comp-slider-container");

    containers.forEach((container) => {
        const slider = container.querySelector(".comp-slider");
        if (!slider) return;

        const current = container.querySelector(".current");
        const future = container.querySelector(".future");

        const updatePosition = (value) => {
            container.style.setProperty("--position", `${value}%`);

            // Hide 'CURRENT' below 25%, hide 'FUTURE' above 75%
            if (current) current.style.opacity = value <= 25 ? 0 : 1;
            if (future) future.style.opacity = value >= 75 ? 0 : 1;
        };

        slider.addEventListener("input", (e) => updatePosition(+e.target.value));

        // Set initial state to match the slider's starting value
        updatePosition(+slider.value);
    });
}
